<template>
  <b-container fluid class="container-with-sidebar container-with-sidebar-admin">
    <Sidebar :collapsed="false"></Sidebar>
    <router-view :key="$route.path"></router-view>
  </b-container>
</template>

<script>
import Sidebar from '@/components/Admin/Sidebar'

export default {
  name: 'BaseAdmin',
  components: {
    Sidebar
  },
  created () {
    this.setCssVariables()
    window.addEventListener('resize', this._.debounce(this.setCssVariables, 300))
  },
  methods: {
    getDimensions () {
      return {
        width: 0.01 * window.innerWidth,
        height: 0.01 * window.innerHeight
      }
    },
    setCssVariables () {
      let dimensions = this.getDimensions()
      let width = dimensions.width
      let height = dimensions.height
      document.documentElement.style.setProperty('--vw', width + 'px')
      document.documentElement.style.setProperty('--vh', height + 'px')
      document.documentElement.style.setProperty('--color-proeduca', '#AF2630')
      document.documentElement.style.setProperty('--lti-font-family', 'Open Sans,sans-serif')
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-container {
  padding-left: 5%;
  padding-right: 5%;
}
</style>



// WEBPACK FOOTER //
// src/containers/BaseAdmin.vue